// extracted by css-extract-rspack-plugin
export default {"picker":"Hu7hgw0MfsIFU66s","legend":"nUpeeN79n5wofguf","option":"JLRWxJvaiB8ZaPnb","optionSecondary":"K5SQyGbFnEYOEQep"};